//import jwtDecode from "jwt-decode";

// const initialState = {
//     best_selling_products: [],
//     menu: [],
//     new_products: [],
//     sections: [],
//     special_offer_products: [],
//     sliders: []
// }
export const ui = (state = {}, action) => {
  switch (action.type) {
    case "UI": {
      return {
        category_parent: action.payload.category_parent,
        best_selling_products: action.payload.best_selling_products,
        brands: action.payload.brands,
        contact_us: action.payload.contact_us,
        menu: action.payload.menu,
        new_products: action.payload.new_products,
        sections: action.payload.sections,
          faq: action.payload.faqs,
        special_offer_products: action.payload.special_offer_products,
          products_hair: action.payload.products_hair,
        products_educational_supplies:
          action.payload.products_educational_supplies,
        sliders: action.payload.sliders,
        articles: action.payload.articles,
        story: action.payload.story,
        settings: action.payload.settings,
      };
    }
    default: {
      return state;
    }
  }
};
